export const TOP_KEYWORDS = {
    ge: {
        main: [
            'მანქანის ყიდვა',
            'მანქანის გაყიდვა',
            'ავტობაზარი',
            'მეორადი მანქანა',
            'მანქანა თბილისში',
            'ავტომობილები საქართველოში',
            'ავტო განცხადება',
            'ავტობაზარი საქართველო',
        ],
        sell: [
            'მანქანის გაყიდვა საქართველოში',
            'ავტომობილის გაყიდვა',
            'მანქანის განცხადება',
            'უფასო განცხადება',
            'მანქანის სწრაფი გაყიდვა',
            'ავტო გაყიდვა',
            'მანქანის ონლაინ გაყიდვა',
            'ავტო განცხადების განთავსება',
            'გაყიდე მანქანა',
            'მანქანის გაყიდვა თბილისი',
        ],
        brands: {
            Toyota: 'ტოიოტა',
            'Mercedes-Benz': 'მერსედესი',
            BMW: 'ბმვ',
            Lexus: 'ლექსუსი',
            Hyundai: 'ჰიუნდაი',
            Kia: 'კია',
        },
        cities: {
            tbilisi: 'თბილისი',
            batumi: 'ბათუმი',
            kutaisi: 'ქუთაისი',
            rustavi: 'რუსთავი',
        },
    },
    ru: {
        main: [
            'купить авто в грузии',
            'купить авто в грузии б/у',
            'продажа авто в грузии сайты',
            'авто сайты грузии на русском',
            'авторынок грузии',
            'продать авто в тбилиси',
            'авторынок тбилиси',
            'купить б/у авто тбилиси',
            'недорогие автомобили грузия',
            'авто объявления грузия',
        ],
        sell: [
            'продать авто в грузии',
            'разместить объявление авто',
            'продажа авто грузия бесплатно',
            'продать машину быстро грузия',
            'продать авто тбилиси',
            'подать объявление о продаже авто',
            'бесплатная продажа авто грузия',
            'продать машину тбилиси быстро',
        ],
    },
    en: {
        main: [
            'buy car georgia',
            'cars for sale georgia',
            'car marketplace georgia',
            'used cars tbilisi',
            'second hand cars georgia',
            'cheap cars tbilisi',
            'buy used car georgia',
        ],
        sell: [
            'sell car georgia',
            'post car ad georgia',
            'free car listing georgia',
            'sell used car tbilisi',
        ],
    },
    ua: {
        main: [
            'купити авто в грузії',
            'авторинок грузії',
            'машини в грузії',
            'вживані авто грузія',
            'б/в авто тбілісі',
        ],
        sell: [
            'продати авто в грузії',
            'розмістити оголошення авто',
            'продати машину тбілісі',
        ],
    },
};

export const ADD_ADVERT_SEO = {
    ge: {
        title: 'გაყიდე მანქანა უფასოდ | განცხადების განთავსება — Worldauto.ge',
        description:
            'გაყიდე მანქანა სწრაფად და უფასოდ! ✓ მყიდველები საქართველოდან და საზღვარგარეთიდან ✓ 0% საკომისიო ✓ 3 წუთში განთავსება ✓ ფოტო და ვიდეო ✓ ქართველი მყიდველები ✓ უსაფრთხო გარიგება — Worldauto.ge',
        keywords:
            'მანქანის გაყიდვა, გაყიდე მანქანა, განცხადების განთავსება, უფასო განცხადება, ავტობაზარი, მანქანის სწრაფი გაყიდვა, ავტო გაყიდვა, მანქანის ონლაინ გაყიდვა, worldauto',
    },
    ru: {
        title: 'Продать авто бесплатно | Разместить объявление — Worldauto.ge',
        description:
            'Продайте авто быстро и бесплатно! ✓ Покупатели из Грузии и из-за рубежа ✓ 0% комиссии ✓ Размещение за 3 минуты ✓ Фото и видео ✓ Местные покупатели ✓ Безопасная сделка — Worldauto.ge',
        keywords:
            'продать авто грузия, продать машину тбилиси, разместить объявление, бесплатное объявление авто, продажа авто грузия бесплатно, быстрая продажа авто, авторынок грузия, worldauto',
    },
    en: {
        title: 'Sell Your Car Free | Post Ad in Georgia — Worldauto.ge',
        description:
            'Sell your car fast and free! ✓ Buyers from Georgia and abroad ✓ 0% commission ✓ List in 3 minutes ✓ Photos & video ✓ Local buyers ✓ Safe transaction — Worldauto.ge',
        keywords:
            'sell car georgia, sell car tbilisi, post car ad free, free car listing, car marketplace georgia, quick car sale georgia, worldauto',
    },
    ua: {
        title: 'Продати авто безкоштовно | Розмістити оголошення — Worldauto.ge',
        description:
            'Продайте авто швидко і безкоштовно! ✓ Покупці з Грузії та з-за кордону ✓ 0% комісії ✓ Розміщення за 3 хвилини ✓ Місцеві покупці ✓ Безпечна угода — Worldauto.ge',
        keywords:
            'продати авто грузія, продати машину тбілісі, розмістити оголошення, безкоштовне оголошення авто, авторинок грузія, worldauto',
    },
};

/**
 * Long-form SEO meta for base search/landing pages without data context.
 * Used when /search/car, /search/bike, /search/parts/* etc. are visited
 * without a city or brand parameter. Targets top GSC queries directly.
 */
export const SEARCH_LANDING_SEO = {
    search_car: {
        ge: {
            title: 'მეორადი მანქანების ყიდვა საქართველოში[[ — %cars% ავტო]] | Worldauto.ge',
            description:
                'მეორადი და ახალი ავტომობილების ყიდვა საქართველოში[[ — %cars% მანქანა]] ✓ Toyota, BMW, Mercedes, Hyundai, Kia ✓ VIN შემოწმება ✓ უფასო განცხადება ✓ 0% საკომისიო ✓ თბილისი, ბათუმი, ქუთაისი — Worldauto.ge.',
        },
        ru: {
            title: 'Купить авто в Грузии[[ — %cars% объявлений б/у]] | Worldauto.ge',
            description:
                'Продажа авто в Грузии[[ — %cars% объявлений]] ✓ Toyota, BMW, Mercedes, Hyundai, Kia ✓ VIN-проверка ✓ 0% комиссии ✓ Тбилиси, Батуми, Кутаиси — Worldauto.ge.',
        },
        en: {
            title: 'Buy Used Cars in Georgia[[ — %cars% Listings]] | Worldauto.ge',
            description:
                "Buy used cars in Georgia[[ — %cars% vehicles]] on Worldauto.ge ✓ Toyota, BMW, Mercedes, Hyundai, Kia ✓ VIN check ✓ Private sellers and dealers ✓ Free car listing.",
        },
        ua: {
            title: 'Купити авто у Грузії[[ — %cars% оголошень]] | Worldauto.ge',
            description:
                'Купити авто у Грузії б/в[[ — %cars% автомобілів]] на Worldauto.ge ✓ Toyota, BMW, Mercedes, Hyundai, Kia ✓ Перевірка VIN ✓ Приватні продавці та дилери ✓ Безкоштовне оголошення.',
        },
    },
    search_bike: {
        ge: {
            title: 'მოტოციკლის ყიდვა-გაყიდვა საქართველოში — მოტოს ყიდვა | Worldauto.ge',
            description:
                'მოტოციკლის ყიდვა-გაყიდვა საქართველოში — Honda, Yamaha, Kawasaki, BMW, KTM, Suzuki, Harley-Davidson ✓ მეორადი მოტო თბილისი, ბათუმი, ქუთაისი ✓ უფასო განცხადება ✓ 0% საკომისიო ✓ კერძო გამყიდველები და დილერები — Worldauto.ge.',
        },
        ru: {
            title: 'Купить мотоцикл в Грузии — Honda, Yamaha, Kawasaki | Worldauto.ge',
            description:
                'Купить мотоцикл в Грузии — Honda, Yamaha, Kawasaki, BMW, KTM, Suzuki ✓ Б/у мотоциклы Тбилиси, Батуми ✓ Бесплатное объявление ✓ Частные продавцы и дилеры — Worldauto.ge.',
        },
        en: {
            title: 'Buy a Motorcycle in Georgia — Honda, Yamaha, Kawasaki | Worldauto.ge',
            description:
                'Buy a motorcycle in Georgia — Honda, Yamaha, Kawasaki, BMW, KTM, Suzuki ✓ Used bikes Tbilisi, Batumi ✓ Free listing ✓ Private sellers and dealers — Worldauto.ge.',
        },
        ua: {
            title: 'Купити мотоцикл у Грузії — Honda, Yamaha, Kawasaki | Worldauto.ge',
            description:
                'Купити мотоцикл у Грузії — Honda, Yamaha, Kawasaki, BMW, KTM, Suzuki ✓ Б/в мотоцикли Тбілісі, Батумі ✓ Безкоштовне оголошення ✓ Приватні продавці та дилери — Worldauto.ge.',
        },
    },
    search_commercial: {
        ge: {
            title: 'სატვირთოს ყიდვა-გაყიდვა საქართველოში — კომერციული ტრანსპორტი | Worldauto.ge',
            description:
                'სატვირთოს და კომერციული ავტომობილების ყიდვა-გაყიდვა საქართველოში — Mercedes Sprinter, Ford Transit, Toyota HiAce, MAN, Scania, DAF, Iveco ✓ მიკროავტობუსები, ფურგონები, სპეცტექნიკა ✓ უფასო განცხადება ✓ 0% საკომისიო — Worldauto.ge.',
        },
        ru: {
            title: 'Купить грузовик в Грузии — коммерческий транспорт | Worldauto.ge',
            description:
                'Купить грузовик и коммерческий транспорт в Грузии — Mercedes Sprinter, Ford Transit, Toyota HiAce, MAN, Scania, DAF ✓ Микроавтобусы, фургоны, спецтехника — Worldauto.ge.',
        },
        en: {
            title: 'Buy Commercial Vehicles in Georgia | Worldauto.ge',
            description:
                'Buy trucks and commercial vehicles in Georgia — Mercedes Sprinter, Ford Transit, Toyota HiAce, MAN, Scania, DAF ✓ Vans, minibuses, special equipment — Worldauto.ge.',
        },
        ua: {
            title: 'Купити вантажівку у Грузії | Worldauto.ge',
            description:
                'Купити вантажівку та комерційний транспорт у Грузії — Mercedes Sprinter, Ford Transit, Toyota HiAce, MAN, Scania, DAF ✓ Мікроавтобуси, фургони, спецтехніка — Worldauto.ge.',
        },
    },
    search_parts: {
        ge: {
            title: 'ავტოს ნაწილების ყიდვა საქართველოში — ავტონაწილები | Worldauto.ge',
            description:
                'ავტოს ნაწილების ყიდვა საქართველოში — ავტონაწილების მაღაზია, ძრავა, გადაცემათა კოლოფი, კარდანი, სამუხრუჭე, ელექტრიკა ✓ ახალი და მეორადი ✓ უფასო განცხადება ✓ თბილისი, ბათუმი, ქუთაისი, რუსთავი — Worldauto.ge.',
        },
        ru: {
            title: 'Автозапчасти в Грузии — купить запчасти | Worldauto.ge',
            description:
                'Купить автозапчасти в Грузии — двигатели, КПП, кузовные детали, тормоза, электрика ✓ Новые и б/у запчасти ✓ Тбилиси, Батуми, Кутаиси ✓ Доставка по Грузии — Worldauto.ge.',
        },
        en: {
            title: 'Auto Parts in Georgia — New & Used Spares | Worldauto.ge',
            description:
                'Buy auto parts in Georgia — engines, gearboxes, body parts, brakes, electrics ✓ New and used parts ✓ Tbilisi, Batumi, Kutaisi ✓ Free listings ✓ Delivery across Georgia — Worldauto.ge.',
        },
        ua: {
            title: 'Автозапчастини у Грузії — купити запчастини | Worldauto.ge',
            description:
                'Купити автозапчастини у Грузії — двигуни, КПП, кузовні деталі, гальма, електрика ✓ Нові та б/в запчастини ✓ Тбілісі, Батумі, Кутаїсі — Worldauto.ge.',
        },
    },
    search_parts_car: {
        ge: {
            title: 'მანქანის ნაწილების ყიდვა საქართველოში — ავტოს ნაწილები | Worldauto.ge',
            description:
                'მანქანის ნაწილების ყიდვა საქართველოში — Toyota, BMW, Mercedes, Hyundai, Kia, Lexus ავტოს ნაწილები ✓ ძრავა, კარდანი, სამუხრუჭე, ელექტრიკა ✓ ახალი და მეორადი ავტონაწილები ✓ თბილისი, ბათუმი, რუსთავი — Worldauto.ge.',
        },
        ru: {
            title: 'Запчасти для авто в Грузии | Worldauto.ge',
            description:
                'Купить запчасти для автомобиля в Грузии — Toyota, BMW, Mercedes, Hyundai, Kia ✓ Двигатели, КПП, тормоза, электрика ✓ Новые и б/у автозапчасти — Worldauto.ge.',
        },
        en: {
            title: 'Car Parts in Georgia — Toyota, BMW, Mercedes Spares | Worldauto.ge',
            description:
                'Buy car parts in Georgia — Toyota, BMW, Mercedes, Hyundai, Kia ✓ Engines, gearboxes, brakes, electrics ✓ New and used auto spares ✓ Free listings — Worldauto.ge.',
        },
        ua: {
            title: 'Запчастини для авто у Грузії | Worldauto.ge',
            description:
                'Купити запчастини для авто у Грузії — Toyota, BMW, Mercedes, Hyundai, Kia ✓ Двигуни, КПП, гальма, електрика ✓ Нові та б/в автозапчастини — Worldauto.ge.',
        },
    },
    search_parts_bike: {
        ge: {
            title: 'მოტოციკლის ნაწილების ყიდვა საქართველოში — მოტოს ნაწილები | Worldauto.ge',
            description:
                'მოტოციკლის ნაწილების ყიდვა საქართველოში — Honda, Yamaha, Kawasaki, BMW, Suzuki, KTM მოტოს ნაწილები ✓ ძრავა, ჯაჭვი, საბურავი, ელექტრიკა ✓ ახალი და მეორადი ✓ თბილისი, ბათუმი — Worldauto.ge.',
        },
        ru: {
            title: 'Запчасти для мотоцикла в Грузии | Worldauto.ge',
            description:
                'Купить запчасти для мотоцикла в Грузии — Honda, Yamaha, Kawasaki, BMW, Suzuki ✓ Двигатели, цепи, шины, электрика ✓ Новые и б/у — Worldauto.ge.',
        },
        en: {
            title: 'Motorcycle Parts in Georgia | Worldauto.ge',
            description:
                'Buy motorcycle parts in Georgia — Honda, Yamaha, Kawasaki, BMW, Suzuki ✓ Engines, chains, tires, electrics ✓ New and used parts — Worldauto.ge.',
        },
        ua: {
            title: 'Запчастини для мотоцикла у Грузії | Worldauto.ge',
            description:
                'Купити запчастини для мотоцикла у Грузії — Honda, Yamaha, Kawasaki, BMW, Suzuki ✓ Двигуни, ланцюги, шини, електрика — Worldauto.ge.',
        },
    },
    search_parts_commercial: {
        ge: {
            title: 'სატვირთოს ნაწილების ყიდვა საქართველოში — კომერციული ავტოს ნაწილები | Worldauto.ge',
            description:
                'სატვირთოს და კომერციული ავტოს ნაწილების ყიდვა საქართველოში — MAN, Scania, DAF, Mercedes, Iveco, Ford Transit ✓ ძრავა, საბურავი, ფარები, ფილტრები ✓ ახალი და მეორადი — Worldauto.ge.',
        },
        ru: {
            title: 'Запчасти для грузовиков в Грузии | Worldauto.ge',
            description:
                'Купить запчасти для грузовиков в Грузии — MAN, Scania, DAF, Mercedes, Iveco ✓ Двигатели, шины, фары, фильтры ✓ Новые и б/у — Worldauto.ge.',
        },
        en: {
            title: 'Commercial Vehicle Parts in Georgia | Worldauto.ge',
            description:
                'Buy commercial vehicle parts in Georgia — MAN, Scania, DAF, Mercedes, Iveco ✓ Engines, tires, lights, filters ✓ New and used — Worldauto.ge.',
        },
        ua: {
            title: 'Запчастини для вантажівок у Грузії | Worldauto.ge',
            description:
                'Купити запчастини для вантажівок у Грузії — MAN, Scania, DAF, Mercedes, Iveco ✓ Двигуни, шини, фари, фільтри — Worldauto.ge.',
        },
    },
    search_rent_car: {
        ge: {
            title: 'ავტოს ქირაობა საქართველოში — დღიური ფასი 30 ₾-დან | Worldauto.ge',
            description:
                'ავტოს ქირაობა / გაქირავება საქართველოში — თბილისი, ბათუმი, ქუთაისი ✓ Toyota, Hyundai, BMW, Mercedes ✓ დღიური ფასი 30 ₾-დან ✓ სწრაფი დაჯავშნა ✓ დაზღვევა — Worldauto.ge.',
        },
        ru: {
            title: 'Аренда авто в Грузии — прокат автомобилей | Worldauto.ge',
            description:
                'Аренда авто в Грузии — Тбилиси, Батуми, Кутаиси ✓ Toyota, Hyundai, BMW, Mercedes ✓ Выгодные цены ✓ Быстрое бронирование ✓ Все классы — Worldauto.ge.',
        },
        en: {
            title: 'Car Rental in Georgia — Rent a Car | Worldauto.ge',
            description:
                'Rent a car in Georgia — Tbilisi, Batumi, Kutaisi ✓ Toyota, Hyundai, BMW, Mercedes ✓ Best prices ✓ Fast booking ✓ All classes — Worldauto.ge.',
        },
        ua: {
            title: 'Оренда авто у Грузії — прокат автомобілів | Worldauto.ge',
            description:
                'Оренда авто у Грузії — Тбілісі, Батумі, Кутаїсі ✓ Toyota, Hyundai, BMW, Mercedes ✓ Вигідні ціни ✓ Швидке бронювання — Worldauto.ge.',
        },
    },
    search_rent_bike: {
        ge: {
            title: 'მოტოციკლის ქირაობა საქართველოში — მოტოს გაქირავება | Worldauto.ge',
            description:
                'მოტოციკლის ქირაობა / გაქირავება საქართველოში — თბილისი, ბათუმი, ქუთაისი ✓ Honda, Yamaha, Royal Enfield, BMW, Harley-Davidson ✓ დღიური ფასი ✓ სწრაფი დაჯავშნა ✓ ჩაბარება ✓ დაზღვევა — Worldauto.ge.',
        },
        ru: {
            title: 'Аренда мотоцикла в Грузии | Worldauto.ge',
            description:
                'Аренда мотоцикла в Грузии — Тбилиси, Батуми ✓ Honda, Yamaha, Royal Enfield, BMW ✓ Посуточно ✓ Быстрое бронирование — Worldauto.ge.',
        },
        en: {
            title: 'Motorcycle Rental in Georgia | Worldauto.ge',
            description:
                'Rent a motorcycle in Georgia — Tbilisi, Batumi ✓ Honda, Yamaha, Royal Enfield, BMW ✓ Daily rates ✓ Fast booking — Worldauto.ge.',
        },
        ua: {
            title: 'Оренда мотоцикла у Грузії | Worldauto.ge',
            description:
                'Оренда мотоцикла у Грузії — Тбілісі, Батумі ✓ Honda, Yamaha, Royal Enfield, BMW ✓ Подобово ✓ Швидке бронювання — Worldauto.ge.',
        },
    },
    search_rent_commercial: {
        ge: {
            title: 'სატვირთოს გაქირავება საქართველოში — კომერციული ტრანსპორტის ქირაობა | Worldauto.ge',
            description:
                'სატვირთო და კომერციული ავტომობილის გაქირავება საქართველოში — Mercedes Sprinter, Ford Transit, Toyota HiAce ✓ მიკროავტობუსები, ფურგონები, სპეცტექნიკა ✓ დღიური ფასი — Worldauto.ge.',
        },
        ru: {
            title: 'Аренда грузовика в Грузии | Worldauto.ge',
            description:
                'Аренда грузовиков и коммерческого транспорта в Грузии — Mercedes Sprinter, Ford Transit ✓ Микроавтобусы, фургоны, спецтехника — Worldauto.ge.',
        },
        en: {
            title: 'Commercial Vehicle Rental in Georgia | Worldauto.ge',
            description:
                'Rent trucks and commercial vehicles in Georgia — Mercedes Sprinter, Ford Transit ✓ Vans, minibuses, special equipment — Worldauto.ge.',
        },
        ua: {
            title: 'Оренда вантажівок у Грузії | Worldauto.ge',
            description:
                'Оренда вантажівок і комерційного транспорту у Грузії — Mercedes Sprinter, Ford Transit ✓ Мікроавтобуси, фургони, спецтехніка — Worldauto.ge.',
        },
    },
    search_services: {
        ge: {
            title: 'ავტოსერვისი თბილისში და საქართველოში — სახელოსნო, ავტომოსარეცხი | Worldauto.ge',
            description:
                'ავტოსერვისი საქართველოში — ავტოსარემონტო სახელოსნო, ავტომოსარეცხი, ავტოსკოლა, ევაკუატორი, საბურავის სერვისი, ტექდათვალიერების სადგური ✓ თბილისი, ბათუმი, ქუთაისი ✓ მისამართები და ტელეფონები ✓ შეფასებები — Worldauto.ge.',
        },
        ru: {
            title: 'Автосервис и ремонт авто в Грузии | СТО, мойки — Worldauto.ge',
            description:
                'Автосервисы в Грузии: ремонт авто, СТО, автомойки, автошколы и эвакуатор ✓ Тбилиси, Батуми ✓ адреса и телефоны — Worldauto.ge.',
        },
        en: {
            title: 'Car Repair & Auto Service in Georgia | Tbilisi — Worldauto.ge',
            description:
                'Find car repair, auto service, car wash, driving schools and tow truck companies in Georgia ✓ Tbilisi, Batumi ✓ addresses and phone numbers — Worldauto.ge.',
        },
        ua: {
            title: 'Автосервіс і ремонт авто у Грузії | СТО, мийки — Worldauto.ge',
            description:
                'Автосервіси у Грузії: ремонт авто, СТО, автомийки, автошколи та евакуатор ✓ Тбілісі, Батумі ✓ адреси й телефони — Worldauto.ge.',
        },
    },
    search_checkauto: {
        ge: {
            title: 'მანქანის შემოწმება VIN კოდით საქართველოში — ავტოს ისტორია ონლაინ | Worldauto.ge',
            description:
                'შეამოწმე მანქანა საქართველოში VIN კოდით ან სახელმწიფო ნომრით ✓ ავარიების ისტორია ✓ რეალური გარბენი ✓ მფლობელები ✓ იურიდიული სისუფთავე ✓ carcheck ყიდვამდე ერთ წუთში — Worldauto.ge.',
        },
        ru: {
            title: 'Проверка авто в Грузии | VIN и история — Worldauto.ge',
            description:
                'Проверка авто в Грузии по VIN ✓ история аварий, пробег, владельцы и юридическая чистота перед покупкой — Worldauto.ge.',
        },
        en: {
            title: 'Carcheck Georgia — Car Check by VIN | Worldauto.ge',
            description:
                'Car check in Georgia by VIN or license plate ✓ accident history, mileage, owners and legal status ✓ instant report before buying — Worldauto.ge.',
        },
        ua: {
            title: 'Перевірка авто у Грузії за VIN | Worldauto.ge',
            description:
                'Перевірка авто у Грузії за VIN або номером ✓ історія ДТП, пробіг, власники та юридична чистота перед купівлею — Worldauto.ge.',
        },
    },
    search_company: {
        ge: {
            title: 'ავტოცენტრი და ავტოდილერები საქართველოში | Worldauto.ge',
            description:
                'ავტოცენტრი და ავტოცენტრები საქართველოში — ავტოდილერები, ავტოსალონები, გაქირავების, ნაწილების და სერვისის კომპანიები ✓ თბილისი, ბათუმი, რუსთავი, ქუთაისი ✓ მისამართები და ტელეფონები ✓ ფასები და შეფასებები — Worldauto.ge.',
        },
        ru: {
            title: 'Автодилеры и автокомпании в Грузии | Worldauto.ge',
            description:
                'Автодилеры, автосалоны, прокатные и сервисные компании в Грузии ✓ адреса и телефоны — Worldauto.ge.',
        },
        en: {
            title: 'Car Dealers & Auto Companies in Georgia | Worldauto.ge',
            description:
                'Car dealers, showrooms, rental and auto service companies in Georgia ✓ addresses and phone numbers — Worldauto.ge.',
        },
        ua: {
            title: 'Автодилери та автокомпанії у Грузії | Worldauto.ge',
            description:
                'Автодилери, автосалони, прокатні та сервісні компанії у Грузії ✓ адреси й телефони — Worldauto.ge.',
        },
    },
    search_placement: {
        ge: {
            title: 'გარაჟის გაქირავება საქართველოში 2026 — ბოქსები და სივრცეები | Worldauto.ge',
            description:
                'გარაჟის, ბოქსის და ავტოსერვისის ფართის გაქირავება და გაყიდვა საქართველოში ✓ განცხადებები მფლობელებისა და კომპანიებისგან ✓ უფასო განცხადება — Worldauto.ge.',
        },
        ru: {
            title: 'Автоплощадки в Грузии | гаражи, боксы и сервисы — Worldauto.ge',
            description:
                'Гаражи, боксы и помещения для автосервиса или автомойки в Грузии ✓ аренда и объявления — Worldauto.ge.',
        },
        en: {
            title: 'Auto Spaces in Georgia | Garages & Service Boxes — Worldauto.ge',
            description:
                'Garages, service boxes and spaces for auto repair or car wash businesses in Georgia ✓ rentals and listings — Worldauto.ge.',
        },
        ua: {
            title: 'Автомайданчики у Грузії | гаражі та бокси — Worldauto.ge',
            description:
                'Гаражі, бокси та приміщення для автосервісу або автомийки у Грузії ✓ оренда та оголошення — Worldauto.ge.',
        },
    },
};

export const SEO_CONFIG = {
    baseUrl: 'https://worldauto.ge',
    siteName: 'Worldauto.ge',
    defaultImage: 'https://worldauto.ge/og-default.png',
    logo: 'https://worldauto.ge/logo.png',

    socialLinks: {
        facebook: 'https://www.facebook.com/profile.php?id=61579279043468',
        instagram: 'https://www.instagram.com/worldauto.ge',
        twitter: '@worldauto_ge',
    },

    // Optional Organization fields used in JSON-LD. Leave a value empty/null
    // to omit the corresponding schema.org property — never output placeholders,
    // Google penalises fabricated business data.
    organization: {
        legalName: 'Dom Group LLC',
        foundingDate: '2024',
        email: 'world.auto.ge@gmail.com',
        telephone: '+995598705983',
        taxID: '402102559',
        address: {
            country: 'GE',
            region: 'Didube',
            locality: 'Tbilisi',
            postalCode: '',
            streetAddress: 'Tsereteli Avenue 56',
        },
    },

    supportedLanguages: ['en', 'ua', 'ru', 'ge'],

    localeMap: {
        en: 'en_US',
        ua: 'uk_UA',
        ru: 'ru_RU',
        ge: 'ka_GE',
    },

    titleLimits: {
        optimal: 110,
        max: 120,
    },

    descriptionLimits: {
        optimal: 310,
        max: 320,
    },

    imageConfig: {
        maxImages: 6,
        ogWidth: 1200,
        ogHeight: 630,
    },
};

export const BASE_TITLE_KEYS = {
    add_advert: 'addAdvertTitle',

    placement_cabinet: 'placement',
    parts_cabinet: 'parts',
    sell_cabinet: 'transportForSell',
    rent_cabinet: 'transportForRent',
    services_cabinet: 'services',

    search_car: 'foundCarSellGeorgia',
    sell_car: 'sellCarGeorgia',
    sell_car_pro: 'sellCarProGeorgia',

    search_bike: 'foundBikeSellGeorgia',
    sell_bike: 'sellBikeGeorgia',
    sell_bike_pro: 'sellBikeProGeorgia',

    search_commercial: 'foundCommercialSellGeorgia',
    sell_commercial: 'sellCommercialGeorgia',
    sell_commercial_pro: 'sellCommercialProGeorgia',

    sell_pro: 'sellProGeorgia',

    search_rent: 'foundRentGeorgia',
    search_rent_car: 'foundCarRentGeorgia',
    rent_car: 'rentCarGeorgia',
    search_rent_bike: 'foundBikeRentGeorgia',
    rent_bike: 'rentBikeGeorgia',
    search_rent_commercial: 'foundCommercialRentGeorgia',
    rent_commercial: 'rentCommercialGeorgia',

    search_parts: 'foundPartsGeorgia',
    parts: 'partsGeorgia',
    search_parts_car: 'foundPartsCarGeorgia',
    parts_car: 'partsCarGeorgia',
    search_parts_bike: 'foundPartsBikeGeorgia',
    parts_bike: 'partsBikeGeorgia',
    search_parts_commercial: 'foundPartsCommercialGeorgia',
    parts_commercial: 'partsCommercialGeorgia',

    search_placement: 'foundPlacementGeorgia',
    placement_box: 'placementBoxGeorgia',
    placement_garage: 'placementGarageGeorgia',
    placement_autoservice: 'placementAutoserviceGeorgia',
    placement_carwash: 'placementCarwashGeorgia',
    placement_painting: 'placementPaintingGeorgia',
    placement_carpaint: 'placementPaintingGeorgia',
    placement_tyreservice: 'placementTyreserviceGeorgia',

    search_services: 'foundServicesGeorgia',
    services_disassembly: 'servicesDisassemblyGeorgia',
    services_autoschool: 'servicesAutoschoolGeorgia',
    services_autoservice: 'servicesAutoserviceGeorgia',
    services_carwash: 'servicesCarwashGeorgia',
    services_painting: 'servicesPaintingGeorgia',
    services_tyreservice: 'servicesTyreserviceGeorgia',
    services_towtruck: 'servicesTowtruckGeorgia',
    services_insurance: 'companyInsuranceGeorgia',

    search_company: 'foundCompanyGeorgia',
    company: 'foundCompanyGeorgia',
    company_autocompany: 'companyAutocompanyGeorgia',
    company_autoexpert: 'companyAutoexpertGeorgia',
    company_rentcompany: 'companyRentcompanyGeorgia',
    company_insurance: 'companyInsuranceGeorgia',
    company_partscompany: 'companyPartscompanyGeorgia',
    company_services: 'companyServicesGeorgia',
    company_add: 'companyGeorgia',
    company_dealer: 'addDealer',
    company_dealer_add: 'addDealer',

    search_checkauto: 'foundCheckautoGeorgia',
    checkauto_report: 'foundCheckautoGeorgia',
    checkauto_example: 'titleExample',

    login: 'signin',
    forgot_password: 'forgotPassword',
    new_password: 'changePassword',
    new_phone: 'changePhone',
    signup_corporate: ['registration', 'corporate'],
    signup_dealer: ['registration', 'dealer'],
    signup_user: ['registration', 'user'],

    cabinet: 'cabinet',
    myCompany: 'myCompany',
    favorites: 'notebook',
    settings: 'settingsAccount',

    privacy_policy: 'titlePrivacyPolicy',
    terms_conditions: 'termsCondition1',
    customs_calculator: 'calculatorPageTitle',
    average_price: 'averagePriceLandingTitle',
    valuator: 'valuatorPageTitle',
    market: 'marketPageTitle',
};

export const VEHICLE_CONDITION_MAP = {
    stateNew: 'https://schema.org/NewCondition',
    stateUsed: 'https://schema.org/UsedCondition',
    stateDamaged: 'https://schema.org/DamagedCondition',
    stateRefurbished: 'https://schema.org/RefurbishedCondition',
};

export const VEHICLE_TYPE_MAP = {
    car: 'Car',
    bike: 'Motorcycle',
    commercial: 'Vehicle',
};

export const FUEL_TYPE_MAP = {
    Petrol: 'Gasoline',
    Diesel: 'Diesel',
    Hybrid: 'Hybrid',
    Electric: 'Electric',
    Gas: 'CNG',
    Hydrogen: 'Hydrogen',
};

export const TRANSMISSION_MAP = {
    Manual: 'ManualTransmission',
    Automatic: 'AutomaticTransmission',
    Robot: 'AutomatedManualTransmission',
    Variator: 'ContinuouslyVariableTransmission',
};

export const DRIVE_TYPE_MAP = {
    Front: 'FrontWheelDrive',
    Rear: 'RearWheelDrive',
    All: 'AllWheelDrive',
    '4WD': 'FourWheelDrive',
};

export const GEORGIA_CITIES = [
    'tbilisi',
    'batumi',
    'kutaisi',
    'rustavi',
    'gori',
    'zugdidi',
    'poti',
    'khashuri',
    'senaki',
    'zestafoni',
    'marneuli',
    'telavi',
    'akhaltsikhe',
    'kobuleti',
    'ozurgeti',
    'kaspi',
    'chiatura',
    'tsqaltubo',
    'sagarejo',
    'gardabani',
    'borjomi',
    'tkibuli',
    'khoni',
    'bolnisi',
    'akhalkalaki',
    'gurjaani',
    'mtskheta',
    'qvareli',
    'akhmeta',
    'kareli',
    'lanchkhuti',
    'dedoplistsqaro',
    'lagodekhi',
    'ninotsminda',
    'abasha',
    'tsnori',
    'jvari',
    'sachkhere',
    'dusheti',
    'signagi',
    'tsalenjikha',
    'vani',
    'baghdati',
    'vale',
    'tetritskaro',
];

export const POPULAR_BRANDS = [
    'Toyota',
    'Mercedes-Benz',
    'BMW',
    'Hyundai',
    'Kia',
    'Volkswagen',
    'Audi',
    'Lexus',
    'Honda',
    'Nissan',
    'Mazda',
    'Ford',
    'Chevrolet',
    'Porsche',
    'Land Rover',
    'Jeep',
    'Subaru',
    'Mitsubishi',
    'Suzuki',
    'Renault',
    'Peugeot',
    'Citroën',
    'Opel',
    'Škoda',
    'Volvo',
    'MINI',
    'Fiat',
    'Alfa Romeo',
    'Jaguar',
    'Bentley',
    'Rolls-Royce',
    'Ferrari',
    'Lamborghini',
    'Maserati',
    'Tesla',
    'Cadillac',
    'Infiniti',
    'Acura',
    'Genesis',
];

export const SEO_TEXTS = {
    ge: {
        sell: {
            prefix: 'ყიდვა',
            action: 'გაყიდვაზე',
            sellerBenefits:
                '✓ უფასო განთავსება ✓ მყიდველები საზღვარგარეთიდან ✓ სწრაფი გაყიდვა ✓ 0% საკომისიო',
            buyerBenefits:
                '✓ VIN შემოწმება ✓ კერძო გამყიდველები და დილერები ✓ რეალური ფოტო ✓ უსაფრთხო',
        },
        rent: {
            prefix: 'დაქირავება',
            action: 'გასაქირავებლად',
            benefits: '✓ ახალი ავტო ✓ დაზღვევა ✓ მიწოდება',
        },
        parts: {
            prefix: 'ნაწილების ყიდვა',
            action: 'ნაწილები',
            benefits: '✓ ორიგინალი ✓ მეორადი ✓ დაბალი ფასი',
        },
    },
    ru: {
        sell: {
            prefix: 'Купить',
            action: 'на продажу',
            sellerBenefits:
                '✓ Бесплатно ✓ Покупатели из-за рубежа ✓ Быстрая продажа ✓ 0% комиссии',
            buyerBenefits:
                '✓ Проверка VIN ✓ Реальные фото ✓ Выгодная цена ✓ Безопасно',
        },
        rent: {
            prefix: 'Арендовать',
            action: 'в аренду',
            benefits: '✓ Новые авто ✓ Страховка включена ✓ Доставка',
        },
        parts: {
            prefix: 'Купить запчасти',
            action: 'запчасти',
            benefits: '✓ Оригинальные запчасти ✓ Б/у детали ✓ Низкие цены',
        },
        services: {
            prefix: 'Заказать',
            action: 'услуги',
            benefits: '✓ Профессиональный сервис ✓ Гарантия качества',
        },
        company: {
            prefix: 'Компания',
            action: 'услуги компании',
            benefits: '✓ Адреса и телефоны ✓ Отзывы клиентов',
        },
    },
    en: {
        sell: {
            prefix: 'Buy',
            action: 'for sale',
            sellerBenefits:
                '✓ Free listing ✓ Buyers from abroad ✓ Quick sale ✓ 0% commission',
            buyerBenefits:
                '✓ VIN check ✓ Private sellers and dealers ✓ Real photos ✓ Safe',
        },
    },
};

export const ROBOTS_CONFIG = {
    index: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1',
    noindex: 'noindex, nofollow',
    indexNoFollow: 'index, nofollow',
};

export const GA_EVENTS = {
    page_view: 'page_view',
    search: 'search',
    select_content: 'select_content',
    view_item: 'view_item',
    add_to_cart: 'add_to_cart',
    begin_checkout: 'begin_checkout',
};
